import PageContainerMobile from 'components/PageContainer/layout/PageContainer.mobile'
import {
  Button,
  IconButton,
  InputAdornment,
  TextField
} from '@material-ui/core'
import { BASE_COLORS, GRAY_COLORS } from 'asterX-UI'
import ChevronLeftIcon from 'asterX-UI/Icons/ChevronLeftIcon'
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import CheckBoxBtn from 'asterX-UI/Inputs/CheckBoxBtn'
import { LANGUAGES } from 'constants/client'
import { KzIcon, LockedIcon, RuIcon } from 'asterX-UI/Icons'
import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'
const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    marginBottom: 20
  },
  heading: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px'
  },
  seoData: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    marginBottom: 'auto',
    height: '100%'
  },
  cardDiv: {
    display: 'flex',
    padding: '24px 16px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 20,
    borderRadius: 12
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
    alignItems: 'center'
  },
  iconedCheckbox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    gap: 8
  }
}))
const UserEdit = ({ onClose }) => {
  const classes = useStyles()
  const {
    store: {
      sale: { client }
    }
  } = useSelectionStore()
  const lockAdornment = (
    <InputAdornment position="start">
      {' '}
      <LockedIcon />
    </InputAdornment>
  )
  return (
    <PageContainerMobile
      customHeader={
        <div className={classes.header}>
          <IconButton
            style={{
              color: GRAY_COLORS[400]
            }}
            onClick={onClose}
            size={'medium'}
          >
            <ChevronLeftIcon />
          </IconButton>
          <div className={classes.heading}>Данные клиента</div>
        </div>
      }
    >
      <div className={classes.seoData}>
        <div className={classes.cardDiv}>
          <TextField
            label={'Имя'}
            fullWidth
            disabled
            required
            value={client?.firstName}
            InputProps={{
              endAdornment: lockAdornment
            }}
          />
          <TextField label={'Отчество'} value={client?.middleName} fullWidth />
          <TextField
            label={'Телефон'}
            fullWidth
            disabled
            required
            value={client?.phoneNumber}
            InputProps={{
              endAdornment: lockAdornment
            }}
          />
          <TextField
            label={'Доп. телефон'}
            fullWidth
            value={client?.additionalPhoneNumber}
          />
          <div
            className={classes.row}
            style={{
              marginTop: 20,
              width: '100%',
              justifyContent: 'space-between'
            }}
          >
            <CheckBoxBtn
              checked={client?.language === LANGUAGES[1].code}
              name={'language'}
              // onClick={({ target }) =>
              //   onChangeSeoClientFields({ [target.name]: LANGUAGES[1].code })
              // }
            >
              <div className={classes.iconedCheckbox}>
                <RuIcon />
                Русский
              </div>
            </CheckBoxBtn>
            <CheckBoxBtn
              checked={client?.language === LANGUAGES[0].code}
              name={'language'}
              // onClick={({ target }) =>
              //   onChangeSeoClientFields({ [target.name]: LANGUAGES[0].code })
              // }
            >
              <div className={classes.iconedCheckbox}>
                <KzIcon />
                Қазақша
              </div>
            </CheckBoxBtn>
          </div>
        </div>
      </div>
      <div className={classes.row}>
        <Button fullWidth variant={'contained'} onClick={onClose}>
          Отмена
        </Button>
        <Button variant={'contained'} color={'primary'} fullWidth>
          Сохранить
        </Button>
      </div>
    </PageContainerMobile>
  )
}

export default UserEdit
